module.exports = __webpack_public_path__ + "static/media/neritoBussines.147d0399.png";